import { FC } from 'react';
import { Modal, ModalProps } from '@lambdacurry/component-library';
import { StripePaymentMethod } from 'lib/home/generated/types/api';
import { EditPaymentMethodForm } from './EditPaymentMethodForm';
import { PaymentMethodIcon, PaymentMethodLabel } from '../..';

export interface EditPaymentMethodModalProps extends ModalProps {
  paymentMethod: StripePaymentMethod;
  onSave: () => void;
  onCancel: () => void;
}

export const EditPaymentMethodModal: FC<EditPaymentMethodModalProps> = ({
  paymentMethod,
  onSave,
  onCancel,
  ...props
}) => (
  <Modal id={`edit-payment-method-modal-${paymentMethod.id}`} {...props}>
    <h3 className="flex gap-4 items-center">
      <PaymentMethodIcon brand={paymentMethod.card.brand} />
      <span>Ending in {paymentMethod.card.last4} </span>
      {paymentMethod.is_default && <PaymentMethodLabel>Default</PaymentMethodLabel>}
    </h3>
    <EditPaymentMethodForm paymentMethod={paymentMethod} onSave={onSave} onCancel={onCancel} />
  </Modal>
);
